var Aneox;
(function (Aneox) {
  'use strict';

  var Animations = (function () {

    var self;

    function Animations() {
      self = this;

      var sequences;
      var orderedSequences;

        
      Object.defineProperties(this, {
        sequences: {
          get: function () {
            return sequences;
          }
        },
        orderedSequences: {
          get: function () {
            return orderedSequences;
          }
        }
      });
      
      this.dataVintages = {};
      this.enabled = false;
      this.scrollSpeed = 1;

      this.isTouchDevice = 'ontouchstart' in window;

      var maskDuration = 1.5;
      var maskEase = Power2.easeInOut;

      function BorderTimeline(element, duration) {
        var timeline = new TimelineMax();
        var ease = Linear.easeNone;

        if (element.hasClass('borders-center')) {
          timeline.from(element.find('.border-top'), duration * .3, {
            scaleX: 0,
            ease: ease
          })
          .from(element.find('.border-vertical'), duration * .4, {
            scaleY: 0,
            ease: ease
          }, duration * .3)
          .from(element.find('.border-bottom-left'), duration * .3, {
            scaleX: 0,
            transformOrigin: 'left',
            ease: ease
          }, duration * .7)
          .from(element.find('.border-bottom-right'), duration * .3, {
            scaleX: 0,
            transformOrigin: 'right',
            ease: ease
          }, duration * .7);
        } else {
          timeline.staggerFrom(element.find('.border-horizontal'), duration / 2, {
            scaleX: 0,
            ease: ease
          }, duration / 2)
          .staggerFrom(element.find('.border-vertical'), duration / 2, {
            scaleY: 0,
            ease: ease
          }, (element.hasClass('borders-right') ? -1 : 1) * duration / 2, 0);
        }

        return timeline;
      };

      this.TextTimeline = function(element) {
        var timeline = new TimelineMax();

        var fadeDuration = .5;
        var fadeStagger = .1;
        var fadeEase = Power1.easeOut;
        
        timeline.staggerFrom(element.find('h3, h4, p'), fadeDuration, {
          opacity: 0,
          y: 20,
          ease: fadeEase
        }, fadeStagger);

        return timeline;
      }

      this.OpeningTimeline = function(element) {
        var timeline = new TimelineMax();

        var borders = element.children('.borders-fullpage');
        var borderDuration = 3.5;
        var borderDelay = .5;

        var maskDuration = 2.5;

        timeline.from(element, maskDuration, {
          y: -940,
          ease: maskEase
        })
        .from(element.children('.opening-background'), maskDuration, {
          y: 940,
          scale: 1.1,
          ease: maskEase
        }, 0)
        .from(borders, maskDuration, {
          y: 940,
          ease: maskEase
        }, 0);

        timeline.add(BorderTimeline(borders, borderDuration), borderDelay);

        timeline.staggerFrom(element.find('.opening-logo-text, h1, h2, button, .domain-social'), .5, {
          opacity: 0
        }, .2, borderDelay + borderDuration / 3);

        return timeline;
      };

      this.SubtitleTimeline = function(element) {
        var timeline = new TimelineMax();

        var ease = Power2.easeOut;
        var duration = 1;
        var stagger = .2;

        var lines = element.find('.line');
        timeline.staggerFrom(lines, duration, {
          y: '110%',
          ease: ease
        }, stagger, '+=0', function() {
          setTimeout(function() {
            lines.removeAttr('style');
          }, 500);
        })
        .from(element.find('.hr'), duration, {
          scaleX: 0,
          ease: ease
        }, '-=' + (duration - stagger));

        return timeline;
      };

      this.ImgTimeline = function(element) {
        var timeline = new TimelineMax();

        // var opacityEase = Power1.easeOut;
        var motionEase = Sine.easeOut;
        var duration = .5;

        var img = element.children('.img-wrap-inner');

        timeline.from(element, duration, {
          scaleX: 0,
          ease: motionEase
        });

        timeline.to(element.find('.img-mask'), duration, {
          x: '100%',
          ease: motionEase
        });

        return timeline;
      };

      this.BorderBoxTimeline = function(element, justBorder) {
        var timeline = new TimelineMax();

        var borderDuration = 2;
        var textDelay = .5;

        timeline.add(BorderTimeline(element.find('.borders'), borderDuration));
        if (!justBorder) {
          timeline.add(self.TextTimeline(element), .5);
        }

        return timeline;
      };

      this.PageBorderTimeline = function(element) {
        var timeline = new TimelineMax();
        timeline.add(BorderTimeline(element, 3.5));
        return timeline;
      }

      self.openOverlay = function(element) {
        element.addClass('active');
        TweenMax.to('#background', maskDuration, {
          display: 'block',
          y: 0,
          ease: maskEase
        });
        TweenMax.to('#background-logo', maskDuration, {
          y: 0,
          ease: maskEase
        });
        TweenMax.to(element.add(element.children('.overlay-wrapper')), maskDuration, {
          display: 'block',
          y: 0,
          ease: maskEase,
          delay: maskDuration * .9
        });

        var gallery = element.children('#gallery-list');
        if (gallery.length > 0) {
          TweenMax.to(gallery, maskDuration, {
            y: 0,
            ease: maskEase,
            delay: maskDuration * .9
          });
        }
      };

      self.handleWindowResize = function(bodyWidth, bodyHeight) {
        TweenMax.set('#background, .overlay.full-height:not(.splash):not(.active)', { y: -bodyHeight });
        TweenMax.set('#background-logo', { y: bodyHeight });

        self.closeOverlay = function(element, onComplete) {
          element.removeClass('active');
          TweenMax.to(element, maskDuration, {
            display: 'none',
            y: -bodyHeight,
            ease: maskEase
          });
          TweenMax.to(element.children('.overlay-wrapper'), maskDuration, {
            y: bodyHeight / 2,
            ease: maskEase
          });
          TweenMax.to('#background', maskDuration, {
            display: 'none',
            y: -bodyHeight,
            ease: maskEase,
            delay: maskDuration * .9,
            onComplete: onComplete
          });
          TweenMax.to('#background-logo', maskDuration, {
            y: bodyHeight,
            ease: maskEase,
            delay: maskDuration * .9
          });
          var gallery = element.children('#gallery-list');
          if (gallery.length > 0) {
            TweenMax.to(gallery, maskDuration, {
              y: bodyHeight,
              ease: maskEase
            });
          }
        };
      }

      
      self.enterSite = function(loader, resources){
        sequences = {
          main: new Aneox.Sequences.Main(self),
          domain: new Aneox.Sequences.Domain(self),
          'savoir-faire': new Aneox.Sequences.SavoirFaire(self),
          wines: new Aneox.Sequences.Wines(self),
          vintages: new Aneox.Sequences.Vintages(self),
          distributors: new Aneox.Sequences.Distributors(self),
          contact: new Aneox.Sequences.Contact(self)
        };
        
        orderedSequences = [
          sequences.domain,
          sequences['savoir-faire'],
          sequences.wines,
          sequences.vintages,
          sequences.distributors,
          sequences.contact
        ];
      }
      
      function completeLoading(){
        setTimeout(function() {
          self.trigger('complete', {type: "imgLoaded"});
        });
      }
    
      preload([
        'sites/default/themes/chavy/assets/2-domaine/visuel_01-90.jpg',
        'sites/default/themes/chavy/assets/2-domaine/visuel_02-90.jpg',
        'sites/default/themes/chavy/assets/2-domaine/visuel_05-90.jpg',
        'sites/default/themes/chavy/assets/3-savoir-faire/visuel_01-90.jpg',
        'sites/default/themes/chavy/assets/3-savoir-faire/visuel_02-90.jpg',
        'sites/default/themes/chavy/assets/3-savoir-faire/visuel_05-90.jpg',
        'sites/default/themes/chavy/assets/5-vins/visuel_01-90.jpg',
        'sites/default/themes/chavy/assets/5-vins/visuel_06-90.jpg',
        'sites/default/themes/chavy/assets/4-millesime/visuel_01-90.jpg',
        'sites/default/themes/chavy/assets/6-distributeurs/visuel_01-90.jpg',
        'sites/default/themes/chavy/assets/7-contact/visuel_01-90.jpg'
      ]);


      function preload(images) {
        // images: array of strings representing src
          
        var nbLoaded = 0;
        var progressElement = $('#preloader-progress');
        var progressValueElement = $('#preloader-progress-value');
        images.forEach(function(src) {
          
          var image = new Image();
          $(image).on('load', function() {
            nbLoaded += 1;
            var proportionLoaded = nbLoaded / images.length;
            updateNumber(Math.round(100 * proportionLoaded), 1);
            TweenMax.killTweensOf(progressElement);
            TweenMax.to(progressElement, 1, {
              scaleY: proportionLoaded,
              ease: Linear.easeNone
            });
            if (nbLoaded === images.length) {
              //enterSite();
              completeLoading();
            }
          });
          image.src = src;
        });

        var currentValue = 0;
        function updateNumber(target, time) {
          var interval = 1000 * time / (target - currentValue);
          (function update() {
            currentValue++;
            progressValueElement.text(currentValue);
            if (currentValue < target) {
              setTimeout(update, interval);
            }
          }) ();
        }
      }
    }
    
    MicroEvent.mixin(Animations);

    return Animations;
  })();

  Aneox.Animations = Animations;
})(Aneox || (Aneox = {}));